import { useMediaQuery } from "native-base";
import CmsLoginPageMobileResponsive from "./mobileResponsive";
import CmsLoginPageWeb from "./web";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";

const CmsLogin = () => {
  const [isSmallScreen] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const getComponents = () => {
    if (isSmallScreen) {
      return <CmsLoginPageMobileResponsive />;
    } else {
      return <CmsLoginPageWeb />;
    }
  };

  return <>{getComponents()}</>;
};

export default CmsLogin;
